// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__-mYOO","spinner":"Spinner_spinner__PQyF1"};